(function () {
  var WIDGET_ID = 'bestsellers';
  var OPEN_EVENT = 'rechilero:floating-panel-open';

  function init() {
    var root = document.querySelector('[data-floating-bestsellers]');
    if (!root || root.dataset.fpInit) return;
    root.dataset.fpInit = '1';

    var toggleBtn = root.querySelector('[data-floating-bestsellers-toggle]');
    var panel = root.querySelector('[data-floating-bestsellers-panel]');
    var dismissBtn = root.querySelector('[data-floating-bestsellers-dismiss]');
    if (!toggleBtn || !panel) return;

    // La burbuja es permanente -- cerrar el panel solo lo colapsa, nunca
    // oculta el widget entero. El div raiz arranca "hidden" en el Liquid
    // solo para evitar el flash-of-content antes de este script.
    root.hidden = false;

    var MOBILE_QUERY = '(max-width: 749px)';
    function isMobile() {
      return window.matchMedia(MOBILE_QUERY).matches;
    }

    // En movil hay un estado extra "pegado" (docked, ver el stylesheet
    // del .liquid) -- mismo mecanismo que rechilero-floating-promos.js:
    // solo el icono, mitad afuera de la pantalla, como reposo por
    // defecto; un primer toque expande a boton completo, el segundo abre
    // el panel. En escritorio no existe este estado intermedio.
    root.dataset.state = isMobile() ? 'docked' : 'expanded';

    function openPanel() {
      root.dataset.state = 'expanded';
      panel.hidden = false;
      toggleBtn.setAttribute('aria-expanded', 'true');
      // Le avisa a otras burbujas flotantes (ej. Ofertas) que se cierren
      // -- dos paneles abiertos a la vez en la misma esquina se pisan
      // visualmente, ver notas de posicionamiento en el .liquid.
      document.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { id: WIDGET_ID } }));
    }

    function closePanel() {
      panel.hidden = true;
      toggleBtn.setAttribute('aria-expanded', 'false');
      if (isMobile()) root.dataset.state = 'docked';
    }

    toggleBtn.addEventListener('click', function () {
      if (isMobile() && root.dataset.state !== 'expanded' && panel.hidden) {
        root.dataset.state = 'expanded';
        return;
      }
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    if (dismissBtn) {
      dismissBtn.addEventListener('click', closePanel);
    }

    document.addEventListener(OPEN_EVENT, function (e) {
      if (e.detail && e.detail.id !== WIDGET_ID && !panel.hidden) closePanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) closePanel();
    });

    document.addEventListener('click', function (e) {
      if (root.contains(e.target)) return;
      if (!panel.hidden) {
        closePanel();
      } else if (isMobile() && root.dataset.state === 'expanded') {
        root.dataset.state = 'docked';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
